import { Box } from '@fuegokit/react';
import React from 'react';

import { Divider } from '../../components/reusable/Divider';
import { PersonalSettings } from '../../components/UserConfiguration/PersonalSettings';
import { TrackingStatusForm } from '../../components/UserConfiguration/TrackingStatusForm';

export function ConfigPersonal() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '22px',
        width: '670px',
        marginTop: '16px',
      }}
    >
      <PersonalSettings />
      <Divider />
      <TrackingStatusForm />
    </Box>
  );
}
